
import {useState} from "react";
import {BUILDING_DETAILS_MAIN_TABS_MODEL} from "../Model/Model";
import CustomTabContainer from "../../../components/CustomTabContainer";
import CustomTab from "../../../components/CustomTab";
import ResidentsTabs from "./Residents/ResidentsTabs";
import UnitsList from "./Units/UnitsList";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const BuildingDetailsMainTabs = ({
    t,
    buildingDetail,
    setModified,
    containerHeight
}) => {
    const [selectedTab, setSelectedTab] = useState(BUILDING_DETAILS_MAIN_TABS_MODEL.RESIDENTS.key);

    return (
        <div className="border-full-shades-300 border-radius-8px p-16px overflow-hidden d-flex flex-column minh-645px" style={{height:containerHeight }}>
            <CustomTabContainer
                activeTab={selectedTab}
                setActiveTab={(e) => {
                    setSelectedTab(e);
                }}
                className="border-0 px-0"
                paddingClass=''
            >
                {Object.values(BUILDING_DETAILS_MAIN_TABS_MODEL).map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item?.icon}
                        selected={selectedTab === item.key}
                        onClick={() => {
                            setSelectedTab(item.key)
                        }}
                    />
                ))}
            </CustomTabContainer>

            <div className="flex-grow-1 min-h-0 d-flex flex-column">
                {selectedTab === BUILDING_DETAILS_MAIN_TABS_MODEL.RESIDENTS.key ? (
                    <ResidentsTabs
                        t={t}
                        buildingDetail={buildingDetail}
                        setModified={setModified}
                    />
                ) : (
                    <UnitsList buildingDetail={buildingDetail} />
                )}
            </div>

        </div>
    );

}

export default BuildingDetailsMainTabs
